@if (asset(); as asset) {
  <a
  class="AssetCard"
  (touchstart)="onTouchStart()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (click)="comparisonMode() && asset.images && asset.images.length ? imageClick.emit({ asset, images }) : cardClick.emit(asset.equipment_number)"
  attr.aria-label="{{asset.year}} {{asset.make}} {{asset.model}}"
  attr.qa-updated="{{ getUpdateDate() | date:'shortDate' }}"
  attr.qa-added="{{ getListingDate() | date:'shortDate' }}"
  data-testid="asset-card"
  colorScheme="assetCard.main"
>
  <div
    [class]="{
      'AssetCard__image': true,
      'AssetCard__image--compare': comparisonMode(),
    }"
  >
    <div
      class="AssetCard__badges"
      colorScheme="assetCard.badges"
    >
      @if (badgesConfig(); as badges) {
        <app-badges-container
          [enabled]="badges.enabled"
          [labelType]="badges.data.labelType ?? 'reversed'"
          [labelModifier]="badges.data.labelModifier ?? 'secondary'"
          [asset]="asset"
        ></app-badges-container>
      }
    </div>
    @if (!comparisonMode()) {
      <div
        class="AssetCard__compare-toggle"
        [class.show]="controlsActive || checkAssetBeingCompared()"
        colorScheme="assetCard.badges"
      >
        <app-comparison-toggle
          [asset]="asset"
          [location]="ComparisonToggleLocation.AssetCard"
        />
      </div>
    }
    @if (asset.images && asset.images.length) {
      @if (showCarousel() && asset.images.length > 1) {
        <swiper-container
          #carouselWrapper
          init="false"
          data-testid="swiper-container"
          >
          @for (img of asset.images; track $index) {
            <swiper-slide data-testid="swiper-slide">
              <img [imageSource]="{
                guid: img,
                transparent: false,
                type: LegacyImageProcessorTypes.CarouselItem,
              }"
                [alt]="asset.year + ' ' + asset.make + ' ' + asset.model + ' image: #' + ($index + 1)"
                loading="lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </swiper-slide>
          }
        </swiper-container>
        <app-icon-button
          icon-btn-small
          icon-btn-icon-medium
          icon-btn-black
          class="AssetCard__carousel-nav-item AssetCard__carousel-nav-item--prev"
          [attr.data-prev]="generateLabel('prev', this.asset()?.equipment_number)"
          matIcon="navigate_before"
        ></app-icon-button>
        <app-icon-button
          icon-btn-small
          icon-btn-icon-medium
          icon-btn-black
          class="AssetCard__carousel-nav-item AssetCard__carousel-nav-item--next"
          [attr.data-next]="generateLabel('next', this.asset()?.equipment_number)"
          matIcon="navigate_next"
        ></app-icon-button>
      } @else {
        @if (asset && asset.images.length) {
          <img
            [imageSource]="{
              guid: asset.images,
              transparent: false,
              type: LegacyImageProcessorTypes.CarouselItem,
            }"
            [alt]="asset.year + ' ' + asset.make + ' ' + asset.model"
            data-testid="image"
            loading="lazy"
          />
        }
      }
    } @else {
      <img [src]="defaultImage()" alt="No photo available" i18n-alt="@@general.no-image.alt" data-testid="image" loading="lazy"/>
    }
  </div>
  <div class="AssetCard__details">
    @if (!comparisonMode()) {
      <div class="overline AssetCard__details--info1">
        @if (!!asset.branch_city) {
          <span>{{asset.branch_city}}</span>
        }
        @if (!!asset.branch_city && !!asset.branch_state) {
          <span>, </span>
        }
        @if (!!asset.branch_state) {
          <span>{{asset.branch_state}}</span>
        }
        @if ((!!asset.branch_city || !!asset.branch_state) && (!!asset.meter_hours || !!asset.meter_miles_precise)) {
          <span> | </span>
        }
        @if (!!asset.meter_hours || !!asset.meter_miles_precise) {
          <span data-testid="meter">{{asset | assetMeter : 'short'}}</span>
        }
      </div>
    }
    <div class="subtitle-1-medium AssetCard__details--info2">
      {{asset.year}} {{asset.make}} {{asset.model}}
    </div>
    <div
      [class]="{ 'AssetCard__details--footer-compare': comparisonMode(), 'AssetCard__details--footer': true }"
    >
      <div
        [style.display]="controlsActive && !comparisonMode() ? 'none' : 'flex'"
        class="h6 price"
        colorScheme="assetCard.price"
        data-testid="price"
      >
        @if (asset.list_price && !asset.is_list_price_hidden) {
          {{asset | assetPrice : currencyCode()}}
        } @else {
          <span i18n="@@asset-card.price-when-hidden">Contact for Pricing</span>
        }
      </div>
      <div
        class="controls"
        [style.display]="!controlsActive ? 'none' : 'flex'"
        data-testid="controls">
        <app-button
          btn-small
          btn-outlined
          data-testid="view-details-button"
          (click)="viewDetailsClicked($event, asset)"
          i18n="@@asset-card.view-details-button.label"
          colorScheme="assetCard.viewButton"
        >View Details</app-button>
        <app-button
          btn-small
          btn-elevated
          (click)="contactClicked($event, asset)"
          data-testid="contact-button"
          i18n="@@asset-card.contact-button.label"
          colorScheme="assetCard.contactButton"
        >Contact</app-button>
      </div>
    </div>
  </div>
</a>
} @else {
  <div class="elevation-5 AssetCard AssetCard--loading">
    <div class="loading" data-testid="loading">
      <mat-spinner diameter="25"></mat-spinner>
    </div>
  </div>
}
